import { createEntityAdapter } from '@reduxjs/toolkit'
import { ColumnDefinition } from './models/ColumnDefinition'

export const columnDefinitionsAdapter = createEntityAdapter({
  selectId: (colDef: ColumnDefinition) => colDef.id,
})
